import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { PrivacySettingsSection, PrivacySettingsValues } from '@gik/inkind-page';
import { useCreateFlowStore } from '@gik/create';
import { Form } from '@gik/ui';
import { privacyStepSchema } from '@gik/create/formSchemas';
import { CreatePageContext } from '@gik/create/components/CreatePage/CreatePage';
import { CreateAnalyticsEvents } from '@gik/create/hooks/useCreateAnalytics';

export interface IPrivacyStepProps {
  onChange?: (values: IPrivacyStepFormValues) => void;
}

const blockName = 'privacy-step';

export interface IPrivacyStepFormValues extends PrivacySettingsValues {}

export default function PrivacyStep({ onChange }: IPrivacyStepProps) {
  const bem = bemBlock(blockName);

  const formValues = useCreateFlowStore(state => state.formValues);
  const { privacyFormRef } = React.useContext(CreatePageContext);

  // TODO: tie form and component together
  return (
    <Form
      ref={privacyFormRef}
      initialValues={formValues}
      className={bem()}
      schema={privacyStepSchema}
      onChange={onChange}
      trackingId={CreateAnalyticsEvents.CREATE_STARTED}
      render={_props => (
        <PrivacySettingsSection onChange={onChange} values={formValues as PrivacySettingsValues} variant="create" />
      )}
    />
  );
}
